import React from "react";

export default function useCopyToClipboard(resetInterval = null) {
	const [isCopied, setCopied] = React.useState(false);

	const handleCopy = React.useCallback(async text => {
		if (typeof text === "string" || typeof text === "number") {
			const textToCopy = text.toString();

			if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
				try {
					await navigator.clipboard.writeText(textToCopy);
					setCopied(true);
					return true;
				} catch {
					setCopied(false);
				}
			}

			if (typeof document === "undefined") {
				setCopied(false);
				return false;
			}

			const textArea = document.createElement("textarea");
			textArea.value = textToCopy;
			textArea.setAttribute("readonly", "");
			textArea.style.position = "absolute";
			textArea.style.left = "-9999px";
			document.body.appendChild(textArea);
			textArea.select();

			const hasCopied = document.execCommand("copy");
			document.body.removeChild(textArea);
			setCopied(hasCopied);
			return hasCopied;
		} else {
			setCopied(false);
			return false;
		}
	}, []);

	React.useEffect(() => {
		let timeout;
		if (isCopied && resetInterval) {
			timeout = setTimeout(() => setCopied(false), resetInterval);
		}
		return () => {
			clearTimeout(timeout);
		};
	}, [isCopied, resetInterval]);

	return [isCopied, handleCopy];
}
